import produce from 'immer';
import { MetaConversation } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

export function updateUserInMetaConversation(
  metaConversation: MetaConversation,
  user: User,
): MetaConversation {
  return produce(metaConversation, (draftMetaConversation) => {
    const authors = draftMetaConversation.conversation.authors;

    for (const authorId in authors) {
      if (user.id === authorId) {
        authors[authorId] = user;
      }
    }

    if (draftMetaConversation.requester?.id === user.id) {
      draftMetaConversation.requester = user;
    }

    draftMetaConversation.messages?.forEach((message) => {
      if (message.author.id === user.id) {
        message.author = user;
      }
    });

    draftMetaConversation.linkedConversations?.forEach((linkedConversation) => {
      if (linkedConversation.requester.id === user.id) {
        linkedConversation.requester = user;
      }
    });
  });
}
